// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1YFp6","list":"BalanceDue_list__1k8lb","listRow":"BalanceDue_listRow__214z1","total":"BalanceDue_total__20GJ8"};